import { Autocomplete, TextField } from '@mui/material';

export type ComboboxOption = { value: string; label: string };

export default function Combobox({ label, value, options, disabled, onChange, placeholder = 'Chọn hoặc tìm kiếm…' }: {
    label: string;
    value: string;
    options: ComboboxOption[];
    disabled?: boolean;
    placeholder?: string;
    onChange: (value: string) => void;
}) {
    return <Autocomplete
        className="ictu-combobox"
        size="small"
        options={options}
        value={options.find(option => option.value === value) || null}
        isOptionEqualToValue={(option, selected) => option.value === selected.value}
        getOptionLabel={option => option.label}
        clearIcon={null}
        disabled={disabled}
        onChange={(_, option) => { if (option) onChange(option.value); }}
        noOptionsText="Không tìm thấy kết quả"
        openText="Mở danh sách"
        closeText="Đóng danh sách"
        componentsProps={{ popper: { className: 'ictu-combobox-popup' } }}
        renderInput={params => <TextField {...params} inputProps={{ ...params.inputProps, 'aria-label': label }} placeholder={placeholder} />}
    />;
}
